import React from 'react';
import { IIconProps } from './utils';

export const Connect = ({
  fill = 'currentColor', height = 42, width = 42, ...rest
}: IIconProps) => (
  <svg
    fill="none"
    height={height}
    viewBox="0 0 42 42"
    width={width}
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M11.4545 13.125C7.06137 13.125 3.5 16.6508 3.5 21C3.5 25.3492 7.06137 28.875 11.4545 28.875H17.8182C22.2114 28.875 25.7727 25.3492 25.7727 21C25.7727 20.1302 25.0605 19.425 24.1818 19.425C23.3032 19.425 22.5909 20.1302 22.5909 21C22.5909 23.6095 20.4541 25.725 17.8182 25.725H11.4545C8.81864 25.725 6.68182 23.6095 6.68182 21C6.68182 18.3905 8.81864 16.275 11.4545 16.275H13.0455C13.9241 16.275 14.6364 15.5698 14.6364 14.7C14.6364 13.8302 13.9241 13.125 13.0455 13.125H11.4545Z"
      fill={fill}
    />
    <path
      d="M24.1818 13.125C19.7886 13.125 16.2273 16.6508 16.2273 21C16.2273 21.8698 16.9395 22.575 17.8182 22.575C18.6968 22.575 19.4091 21.8698 19.4091 21C19.4091 18.3905 21.5459 16.275 24.1818 16.275H30.5455C33.1814 16.275 35.3182 18.3905 35.3182 21C35.3182 23.6095 33.1814 25.725 30.5455 25.725H28.9545C28.0759 25.725 27.3636 26.4302 27.3636 27.3C27.3636 28.1698 28.0759 28.875 28.9545 28.875H30.5455C34.9386 28.875 38.5 25.3492 38.5 21C38.5 16.6508 34.9386 13.125 30.5455 13.125H24.1818Z"
      fill={fill}
    />
  </svg>
);
